// pages/SuperAdminPage.tsx
import React, { useEffect, useState } from 'react'

import { columnsSuperAdmin } from '../../components/Tables/SuperAdmin/Columns'

import VisibilityIcon from '@mui/icons-material/Visibility'
import { IconButton } from '@mui/material'
import { useLoading } from '../../Provider/LoadingProvider'
import Modal from '../../components/GeneralComponents/Modal'
import Table from '../../components/Table'
import DeleteButton from '../../components/Table/components/DeleteButton'
import FormSuperAdmin from '../../components/Tables/SuperAdmin/Form'
import { deleteSuperAdmin, listSuperAdmins } from '../../services/super_admin'
import { SuperAdmin } from '../../types/super_admin'
import { Pagination } from '../../types/types'
import './style.scss'

const SuperAdminPage = () => {
  const [data, setData] = useState<Pagination<SuperAdmin>>({
    currentPage: 1,
    hasNextPage: false,
    hasPrevPage: false,
    total: 1,
    totalPages: 1,
    data: []
  })
  const limit = 6
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [search, setSearch] = useState('')
  const [filteredBySearch, setFilteredBySearch] = useState(false)
  const [selected, setSelected] = useState<SuperAdmin | undefined>(undefined)
  const { startLoading, stopLoading } = useLoading()

  useEffect(() => {
    getData(search.length > 3 ? search : '', data.currentPage)
  }, [])

  useEffect(() => {
    if (search.length >= 3) {
      setFilteredBySearch(true)
      getData(search, 1)
    } else if (filteredBySearch) {
      setFilteredBySearch(false)
      getData('', 1)
    }
  }, [search])

  useEffect(() => {
    getData(search, data.currentPage)
  }, [data.currentPage])

  const onCloseModal = () => {
    setIsOpenModal(false)
    setSelected(undefined)
  }

  const handleOpenModal = () => {
    setIsOpenModal(true)
  }

  const getData = async (searchValue: string, page: number) => {
    try {
      startLoading()
      const superAdmins = await listSuperAdmins({
        params: { page, search: searchValue, limit }
      })
      setData(superAdmins)
    } catch (error) {
      console.error(error)
    } finally {
      stopLoading()
    }
  }

  const handleSubmit = async () => {
    setIsOpenModal(false)
    await getData(search.length > 3 ? search : '', data.currentPage)
  }

  const handlePageChange = (newPage: number) => {
    getData(search.length >= 3 ? search : '', newPage)
  }

  const handleView = (id: SuperAdmin) => {
    setSelected(id)
  }

  const handleDelete = async (id: string) => {
    try {
      startLoading()
      await deleteSuperAdmin(id)
      await getData(search.length > 3 ? search : '', data.currentPage)
    } catch (error) {
      console.error(error)
    } finally {
      stopLoading()
    }
  }

  const Actions = ({ id, item }: { id: string; item?: SuperAdmin }) => {
    return (
      <>
        <IconButton onClick={() => handleView(item as SuperAdmin)}>
          <VisibilityIcon style={{ color: 'white' }} />
        </IconButton>
        <DeleteButton OnDelete={() => handleDelete(id)} />
      </>
    )
  }

  useEffect(() => {
    if (selected) {
      setIsOpenModal(true)
    }
  }, [selected])

  return (
    <>
      <div className='superAdminContainer'>
        <div className='title'>
          <p>Super Admins</p>
        </div>
        <div className='tableContainer'>
          <Table
            onPageChange={handlePageChange}
            onChangeSearch={setSearch}
            pagination={data}
            handleOpenModal={handleOpenModal}
            columns={columnsSuperAdmin}
            Actions={Actions}
            itemsPerPage={limit}
          />
        </div>
      </div>
      <Modal isOpen={isOpenModal} onClose={onCloseModal}>
        <FormSuperAdmin initialValue={selected} onSubmit={handleSubmit} />
      </Modal>
    </>
  )
}

export default SuperAdminPage
